/**
 *
 * @param {integer} max - max length of the text, cut to this number of chars,
 * @param {string, default: '&nbsp;&hellip;'} tail - add this string to the input
 * @param {boolean} wordwise - if true, cut only by words bounds
 * @returns {function} string if the string was cut.
 *
 * @example
 *  Usage:
 *   {{some_text | cut:100:' ...',true}}
 *
 */
export default () => {
  return (value, max, tail, wordwise) => {
    if (!value) {
      return '';
    }

    max = parseInt(max, 10);
    if (!max) {
      return value;
    }
    if (value.length <= max) {
      return value;
    }

    value = value.substr(0, max);
    if (wordwise) {
      const lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        value = value.substr(0, lastspace);
      }
    }
    return value + (tail || ' …');
  };
};



// WEBPACK FOOTER //
// src/app/common/filters/cut.text.filter.ts